var map = {
	"./calendar.html": 3,
	"./calendarDayView.html": 4,
	"./calendarHourList.html": 5,
	"./calendarMonthCell.html": 6,
	"./calendarMonthCellEvents.html": 7,
	"./calendarMonthView.html": 8,
	"./calendarSlideBox.html": 9,
	"./calendarWeekView.html": 10,
	"./calendarYearView.html": 11
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;



/*****************
 ** WEBPACK FOOTER
 ** ./src/templates nonrecursive \.html
 ** module id = 38
 ** module chunks = 0
 **/